export const ENROLLMENT_STATUSES = ['not_started', 'open', 'started', 'complete'];
export const INCOMPLETE_ENROLLMENT_STATUSES = ['not_started', 'open', 'started'];
